import {createTV} from 'tailwind-variants';

export const tv = createTV({
  twMerge: false,
});
